module.exports = __webpack_public_path__ + "img/slide-bg.5b0e2961.png";